import api from 'api'
import { WORK_ORDER_CACHE_INVALIDATION_TAGS, withDelayedWorkOrderInvalidation } from 'api/cacheInvalidationTagSets'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    revertInvoiceToDraft: build.mutation({
      query: ({ id }) => ({ url: `/api/v1/billing/invoice/${id}/revert-to-draft`, method: 'POST' }),
      invalidatesTags: [...WORK_ORDER_CACHE_INVALIDATION_TAGS],
      onQueryStarted: withDelayedWorkOrderInvalidation({ api }),
    }),
    revertInvoiceListToDraft: build.mutation({
      query: ({ invoiceIds }) => ({ url: `/api/v1/billing/invoice/revert-to-draft`, method: 'POST', body: { invoiceIds } }),
      invalidatesTags: [...WORK_ORDER_CACHE_INVALIDATION_TAGS],
      onQueryStarted: withDelayedWorkOrderInvalidation({ api }),
    }),
  }),
})

export const { useRevertInvoiceToDraftMutation, useRevertInvoiceListToDraftMutation } = extendedApi
